import { useEffect, useState } from 'react';

const useOnHover = (ref: React.RefObject<HTMLElement>): boolean => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = (e: MouseEvent) => {
    if (ref.current && ref.current.contains(e.target as Node) && e.target instanceof Node) {
      setIsHovering(true);
    } else {
      setIsHovering(false);
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('mouseover', handleMouseOver);

    return () => {
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  return isHovering;
};

export default useOnHover;
